import React, { useEffect, useState } from "react";

import { iconsService } from "../../../features/Shared/Components/MacroIcon/iconsService";
import { IconContainer } from "./styles";

export const getIconType = (icon) => {
  const iconKits = [
    "material-design/",
    "font-awesome/",
    "bootstrap/",
    "atlaskit/",
  ];

  if (typeof icon === "object") {
    return "emoji";
  }

  if (iconKits.some((name) => icon.startsWith(name))) {
    return "icon";
  }

  return "app";
};

const Icon = ({ icon, size }) => {
  const [providerIcon, setProviderIcon] = useState(undefined);

  useEffect(() => {
    const getProviderIcon = async () => {
      try {
        const response = await iconsService.fetchIcons(icon);

        if (response.status === 200) {
          setProviderIcon(response.data.svg);
        }
      } catch (error) {
        return undefined;
      }
    };

    getProviderIcon();
  }, [icon]);

  return (
    <IconContainer
      dangerouslySetInnerHTML={{ __html: providerIcon }}
      size={size}
    />
  );
};

export default Icon;
